// Test IDs for the auth feature (login, register, password reset, logout).
// Add new keys here as you wire up additional auth UI; see ./index.js for
// the recipe to add a new feature file.
//
// Directive:
//   - Keys are camelCase, values are kebab-case shaped as `<feature>-<element>`
//     (or `<feature>-<element>-<qualifier>` when an element repeats). Examples:
//     'login-submit-button', 'cart-quantity-input', 'product-card-image'.
//   - Reference them in JSX as `data-testid={LOGIN.submitButton}`.
//
// Why kebab-case values: required by qabot's CSS-attribute selector matcher
// and the lint rule `emergent(kebab-case-testid)`.

export const LOGIN = {
        emailInput: 'login-email-input',
        passwordInput: 'login-password-input',
        submitButton: 'login-submit-button',
        forgotPasswordLink: 'login-forgot-password-link',
        registerLink: 'login-register-link',
};

export const REGISTER = {
        nameInput: 'register-name-input',
        emailInput: 'register-email-input',
        passwordInput: 'register-password-input',
        passwordConfirmInput: 'register-password-confirm-input',
        submitButton: 'register-submit-button',
        loginLink: 'register-login-link',
};

export const LOGOUT = {
        button: 'logout-button',
};

// Header-triggered Sign In modal (Stage 12B).
export const AUTH_MODAL = {
        openButton: 'header-signin-button',
        openButtonMobile: 'header-signin-button-mobile',
        dialog: 'auth-modal',
        tabSignin: 'auth-tab-signin',
        tabRegister: 'auth-tab-register',
        signinEmail: 'auth-signin-email',
        signinPassword: 'auth-signin-password',
        signinSubmit: 'auth-signin-submit',
        registerName: 'auth-register-name',
        registerEmail: 'auth-register-email',
        registerPhone: 'auth-register-phone',
        registerPassword: 'auth-register-password',
        registerSubmit: 'auth-register-submit',
        googleButton: 'auth-google-button',
        appleButton: 'auth-apple-button',
        idmeButton: 'auth-idme-button',
};

// ID.me military/veteran verification (Stage 12B — live via OIDC).
export const MILITARY_VERIFY = {
        card: 'military-verify-card',
        verifyButton: 'idme-verify-button',
        verifiedBadge: 'military-verified-badge',
        veteranBadge: 'veteran-verified-badge',
};

// Veteran-only gated area.
export const VETERAN = {
        page: 'veterans-circle-page',
        gate: 'veteran-gate',
};
